import React, { useState, useEffect, useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import  { API_BASE_URL } from '../services/api';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Building2, Loader2 } from "lucide-react";

const OrganizationSelector = ({ isSuperAdmin }) => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const { organizationId, setOrganizationId } = useContext(OrganizationContext);

  useEffect(() => {
    console.log('OrganizationSelector isSuperAdmin='+isSuperAdmin);
    if (isSuperAdmin) {
      fetchOrganizations();
    }
  }, [isSuperAdmin]);

  const fetchOrganizations = async () => {
    setLoading(true);
    try {
      // This would call your API to get all organizations
      console.log('fetchOrganizations');
      const response = await fetch(`${API_BASE_URL}/organizations`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setOrganizations(data);
      } else {
        console.error('Failed to fetch organizations');
      }
    } catch (error) {
      console.error('Error fetching organizations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOrganizationChange = (value) => {
    setOrganizationId(value);
    // You may want to update local storage or perform other actions here
  };

  if (!isSuperAdmin) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 max-w-xs">
      <div className="text-sm font-medium text-gray-500 hidden md:block">Organization:</div>
      {loading ? (
        <div className="flex items-center">
          <Loader2 className="h-4 w-4 animate-spin mr-2" />
          <span className="text-sm">Loading...</span>
        </div>
      ) : (
        <Select 
          value={organizationId} 
          onValueChange={handleOrganizationChange}
        >
          <SelectTrigger className="border-none shadow-none h-8 pl-2 focus-visible:ring-0">
            <Building2 className="h-4 w-4 mr-2 text-muted-foreground" />
            <SelectValue placeholder="Select organization" />
          </SelectTrigger>
          <SelectContent>
            {organizations.map((org) => (
              <SelectItem key={org.id} value={org.id.toString()}>
                {org.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};

export default OrganizationSelector;